import { gql } from '@apollo/client'

export const GET_SEO_BY_ID = gql`
  query OSeoById($input: oSeoByIdInput) {
    oSeoById(input: $input) {
      sSlug
      sTitle
      eType
      eSubType
      eCode
      sDescription
    }
  }
`

export const GET_SUB_PAGE_BY_SLUG_RAW = gql`
  query GetSeosBySlug($input: oSeosByIdInput) {
    getSeosBySlug(input: $input) {
      sSlug
      eSubType
      sDTitle
      sContent
      iId
    }
  }
`

export const GET_SUB_PAGE_BY_SLUG = gql`
  query GetSeosBySlug($subPageInput: oSeosByIdInput) {
    getSeosBySlug(input: $subPageInput) {
      sSlug
      eSubType
      sDTitle
      sContent
    }
  }
`
export const GET_SEO_DATA = gql`
  query GetSeoData($input: oSlugData) {
    getSeoData(input: $input) {
      _id
      aKeywords
      eStatus
      oFB {
        sUrl
        sTitle
        sDescription
      }
      oTwitter {
        sUrl
        sTitle
        sDescription
      }
      sCUrl
      sDescription
      sRobots
      eSchemaType
      eTabType
    }
  }
`
